// 数据统计相关API

import request from "@/utils/request"

/**
 * 获取日用电统计
 * @param {*} data 
 * @returns 
 */
export function getUseElecStatisticDaliyApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/UseElecStatisticDaliy",
    method: "post",
    data
  })
}


/**
 * 获取日充电情况统计
 * @param {*} data 
 * @returns 
 */
export function getchargeOrderStatisticDaliyApi(data) {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/ChageOrderStatisticDaliy",
    method: "post",
    data
  })
}


/**
 * 获取首页运营数据
 * @param {*}  
 * @returns 
 */
export function getHomeCurMonthBusiDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_CurMonth_BusiData",
    method: "get"
  })
}

/**
 * 获取首页湖南省充电站点分布
 * @param {*}  
 * @returns 
 */
export function getHomeAllSitesDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_All_Sites_Fb",
    method: "get"
  })
}


/**
 * 获取首页设备概要树
 * @param {*}  
 * @returns 
 */
export function getHomeDeviceTreeDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_DeviceTree",
    method: "get"
  })
}

/**
 * 获取首页月用电量趋势数据
 * @param {*}  
 * @returns 
 */
export function getHomeUseElectChartDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_UseElectChart",
    method: "get"
  })
}


/**
 * 获取首页各个站点运营排行
 * @param {*}  
 * @returns 
 */
export function getHomeUseElectSiteYxPhDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_UseElectSiteYxPh",
    method: "get"
  })
}


/**
 * 获取首页故障统计数据
 * @param {*}  
 * @returns 
 */
export function getHomeFualtTjDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_FualtTj",
    method: "get"
  })
}

/**
 * 获取首页调控功率的数据
 * @param {*}  
 * @returns 
 */
export function getHomeStrateDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_StrateView",
    method: "get"
  })
}


/**
 * 获取大屏设备总览数据（在线 / 离线 / 充电中 / 空闲 / 故障）
 * 说明：该路径为示例假路径，后端接口就绪后替换 url 即可
 * 预期返回结构：{ online_num, offline_num, charging_num, idle_num, fault_num }
 * @param {*}
 * @returns
 */
export function getHomeDeviceOverviewDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_DeviceOverView",
    method: "get"
  })
}

/**
 * 获取大屏安全监测数据（正常 / 预警 / 报警次数 + 异常明细列表）
 * 说明：该路径为示例假路径，后端接口就绪后替换 url 即可
 * 预期返回结构：
 * {
 *   normal_num,            // 监测到正常的次数
 *   warn_num,              // 预警次数
 *   alarm_num,             // 报警次数
 *   list: [
 *     { alarm_time, type_name, level, address } // level：1 预警，2 报警
 *   ]
 * }
 * @param {*}
 * @returns
 */
export function getHomeSafeMonitorDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Index_SafeMonitor",
    method: "get"
  })
}

/**
 * 财务管理中财务概览中的数据总览
 * @param {*}  
 * @returns 
 */
export function getHomeFinanceOverViewDataApi() {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Cw_OverView",
    method: "get"
  })
}

/**
 * 获取财务管理-财务概览中的费用统计数据
 * @param {*} params 
 * @returns 
 */
export function getFinanceFeeStatisticDataApi(params) {
  return request({
    url: "/Anno.Plugs.DevRun/Statistics/Cw_Fee_Statistic",
    method: "get",
    params
  })
}